import type {
  CatalogEdition,
  EditionModule,
} from '@/lib/whats-new/edition-types';
import {
  ESTREIA_ID,
  estreiaEdition,
} from '@/components/whats-new/editions/estreia';

/**
 * Edition modules by catalog id. Publishing an edition = a module here plus a
 * migration that inserts its row in `news_editions`.
 */
export const EDITIONS: Readonly<Record<string, EditionModule>> = {
  [ESTREIA_ID]: estreiaEdition,
};

/**
 * The edition that opens on its own (NEWS-20): the first one of the catalog
 * (already newest first) that has a module; ids without a module are skipped.
 */
export function resolveLatest(
  catalog: readonly CatalogEdition[],
  editions: Readonly<Record<string, EditionModule>> = EDITIONS
): CatalogEdition | null {
  return (
    catalog.find((edition) =>
      Object.prototype.hasOwnProperty.call(editions, edition.id)
    ) ?? null
  );
}
